import React, {useEffect, useState} from 'react';
import {makeStyles, MenuItem, TextField} from '@material-ui/core';
import {ISelectorListProps} from "app/bookings/new/RepeatBooking/types";


export const SelectorList = ({selectedOption, listOfOptions, onSelectedOptionChange, disabled, classPrefix}: ISelectorListProps) => {
  const useStyle = makeStyles({
    dropDown: {
      [`& .${classPrefix}-MuiFormControl-root`]: {
        marginTop: 4,
        width: 150
      }
    },
    menu: {
      display: 'flex',
      flexDirection: 'column',
    },
    menuList: {
      margin: '5px !important'
    }
  });

  const classes = useStyle();

  return (
    <div className={classes.dropDown}>
      <TextField
        data-testid="recurring-booking-type"
        select
        variant="standard"
        disabled={disabled}
        value={selectedOption}
        InputLabelProps={{shrink: true}}
        SelectProps={{
          MenuProps: {
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            getContentAnchorEl: null,
            classes: {
              list: classes.menu
            }
          }
        }}
        onChange={event => onSelectedOptionChange(event.target.value)}>
        {
          listOfOptions.map((option) => (
            <MenuItem className={classes.menuList} key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))
        }
      </TextField>
    </div>
  )
}
